module.exports = __webpack_public_path__ + "img/dynamic-21.9518668b.png";